import { useMemo } from 'react';
import { Button, ButtonGroup, Flex, TextButton } from '@zillow/constellation';
import { TourActionButton } from '@zg-rentals/ts-z-calendar-client';

import type { TourEvent } from '../../../../../constants';

type TourEventPreviewPopoverBodyFooterProps = {
  event: TourEvent;
  onDeclineClick: () => void;
  onConfirmClick: () => void;
  onCancelTourInitialClick: () => void;
};
const TourEventPopoverBodyFooter = ({
  event,
  onDeclineClick,
  onConfirmClick,
  onCancelTourInitialClick,
}: TourEventPreviewPopoverBodyFooterProps) => {
  const tourEventFooterButtons = useMemo(() => {
    const eventAllowsCancel = event.allowedLandlordActions.includes(TourActionButton.CANCEL);
    const eventAllowsDeclineAndConfirm =
      event.allowedLandlordActions.includes(TourActionButton.DECLINE) &&
      event.allowedLandlordActions.includes(TourActionButton.CONFIRM);

    if (eventAllowsCancel) {
      return [
        <TextButton
          buttonType="primary"
          onClick={onCancelTourInitialClick}
          data-testid="TourEventPopoverBody-CancelBtn"
          key="cancel"
        >
          Cancel tour
        </TextButton>,
      ];
    }

    if (eventAllowsDeclineAndConfirm) {
      return [
        <TextButton onClick={onDeclineClick} data-testid="TourEventPopoverBody-DeclineBtn" key="decline">
          Decline
        </TextButton>,
        <Button
          buttonType="primary"
          onClick={onConfirmClick}
          data-testid="TourEventPopoverBody-ConfirmBtn"
          key="confirm"
        >
          Confirm
        </Button>,
      ];
    }
  }, [event]);

  return (
    <Flex
      as={ButtonGroup}
      display="flex"
      justifyContent="flex-end"
      aria-label="Tour event form buttons"
      data-testid="TourEventPopoverBody-Footer"
    >
      {tourEventFooterButtons}
    </Flex>
  );
};

export default TourEventPopoverBodyFooter;
